var render = function render(){var _vm=this,_c=_vm._self._c;return _c('actions-cell',{attrs:{"name":"actions","actions":_vm.actions},on:{"action":_vm.handleAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }